import {gsap} from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger.js";

import { generalStore } from "./GeneralStore.js";

gsap.registerPlugin(ScrollTrigger);

export class Functionalities {
    constructor() {
        this.setWindowWidthvalue()
        this.toggleNavigationMenu();
        this.showCurrentButtonCases();
        this.closeNavigationMenu();
        this.navigationItemsHandling();
    }

    setWindowWidthvalue() {
        generalStore.setState({windowWidth: window.innerWidth})

        window.addEventListener('resize', () => {
            generalStore.setState({windowWidth: window.innerWidth})
        })
    }

    navigationItemsHandling() {
        const navigationItems = document.getElementsByClassName('navigation__item');

        generalStore.setState({navState: generalStore.state.windowWidth < 1024 ? 'mobile' : 'desktop'})

        generalStore.watch('windowWidth', (newValue) => {
            generalStore.setState({navState: newValue < 1024 ? 'mobile' : 'desktop'})
        })

        if (generalStore.state.navState === 'mobile') {
            this.navigationItemsMobile(navigationItems)
        } else {
            this.navigationItemsDesktop(navigationItems)
        }

        generalStore.watch('navState', (newValue) => {
            if (newValue === 'mobile') {
                this.navigationItemsMobile(navigationItems)
            } else {
                this.navigationItemsDesktop(navigationItems)
            }
        })
    }

    navigationItemsMobile(navigationItems) {
        Array.from(navigationItems).forEach(item => {
            if (!item.children[1].classList.contains('hidden')) {
                item.children[1].classList.add('hidden')
            }

            if (!item.children[0].hasClickListener) {
                gsap.set(item.children[0].children[1], {
                    rotate: 90
                })

                item.children[0].dropdownHandler = () => this.toggleDropdown(item)

                item.children[0].addEventListener('click', item.children[0].dropdownHandler)
                item.children[0].hasClickListener = true;
            }
        })
    }

    navigationItemsDesktop(navigationItems) {
        Array.from(navigationItems).forEach(item => {
            if (item.children[1].classList.contains('hidden')) {
                item.children[1].classList.remove('hidden')
            }

            if (item.children[0].hasClickListener) {
                gsap.set(item.children[0].children[1], {
                    rotate: 0
                })

                item.children[0].removeEventListener('click', item.children[0].dropdownHandler);
                delete item.children[0].dropdownHandler;
                item.children[0].hasClickListener = false;
            }
        })
    }

    toggleDropdown(item) {
        if (!item.children[1].classList.contains('hidden')) {
            gsap.to(item.children[0].children[1], {
                rotate: 90,
                duration: 0.3
            })
            item.children[1].classList.add('hidden')
        } else {
            gsap.to(item.children[0].children[1], {
                rotate: -90,
                duration: 0.3
            })
            item.children[1].classList.remove('hidden')
        }
    }

    toggleNavigationMenu() {
        const toggleButton = document.getElementById('toggle-button')
        const navCta2 = document.getElementById('navCta2')

        if (toggleButton) {
            toggleButton.addEventListener('click', () => {
                generalStore.toggleNav()
            })
        }

        if (navCta2) {
            navCta2.addEventListener('click', () => {
                console.log( 'ypep' );
                generalStore.toggleNav()
            })
        }

        generalStore.watch('navOpen', () => {
            this.showNavigationMenu();
            this.manageToggleIcons();
            this.coloringElements();
            document.body.classList.toggle('nav-is-open', generalStore.state.navOpen);
        })
    }

    closeNavigationMenu() {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && generalStore.state.navOpen) {
                this.showNavigationMenu()
                generalStore.setState({navOpen: false})
            }
        })
    }

    showNavigationMenu() {
        const navMenu = document.getElementById('nav-menu')

        if (navMenu && generalStore.state.navOpen) {
            navMenu.classList.remove('hidden')
        } else {
            navMenu.classList.add('hidden')
        }
    }

    manageToggleIcons() {
        const hamburgerIcon = document.getElementById('icon-hamburger')
        const crossIcon = document.getElementById('icon-cross')

        if (hamburgerIcon && crossIcon && generalStore.state.navOpen) {
            hamburgerIcon.classList.add('hidden')
            crossIcon.classList.remove('hidden')
        } else {
            hamburgerIcon.classList.remove('hidden')
            crossIcon.classList.add('hidden')
        }
    }

    coloringElements() {
        const navMenuWrapper = document.getElementById('nav-menu-wrapper')
        const toggleButton = document.getElementById('toggle-button-text')
        const logoWrapper = document.getElementById('logo-wrapper')
        const navCta = document.getElementById('navCta')

        if (navMenuWrapper && toggleButton && generalStore.state.navOpen) {
            navMenuWrapper.classList.remove('mix-blend-difference', 'text-white')
            navMenuWrapper.classList.add('text-primary-900')
        } else {
            navMenuWrapper.classList.add('mix-blend-difference', 'text-white')
            navMenuWrapper.classList.remove('text-primary-900')
        }

        if (toggleButton && generalStore.state.navOpen) {
            toggleButton.classList.remove('text-white')
            toggleButton.classList.add('text-primary-900')
        } else {
            toggleButton.classList.add('text-white')
            toggleButton.classList.remove('text-primary-900')
        }

        if (logoWrapper && generalStore.state.navOpen) {
            logoWrapper.classList.remove('mix-blend-difference', 'text-white')
            logoWrapper.classList.add('text-primary-900')
        } else {
            logoWrapper.classList.remove('text-primary-900')
            logoWrapper.classList.add('mix-blend-difference', 'text-white')
        }

        if (navCta && generalStore.state.navOpen) {
            navCta.classList.remove('button--neutral')
            navCta.classList.add('button--mint')
        } else {
            navCta.classList.add('button--neutral')
            navCta.classList.remove('button--mint')
        }
    }

    showCurrentButtonCases() {
        let cases = Array.from(document.getElementsByClassName('case-buttons'));

        if (cases.length > 0) {
            cases.forEach(item => {
                item.classList.add('hidden')
            })

            cases[generalStore.state.currentReferencesSlide].classList.remove('hidden');

            generalStore.watch('currentReferencesSlide', (newState, oldState) => {
                cases[newState].classList.remove('hidden');
                cases[oldState].classList.add('hidden');
            })
        }
    }
}
